import NavBarHome from "../components/NavBarHome";
import GetInTouch1 from "../components/GetInTouch1";
import Address_Frame from "../components/Address_Frame";

const GetInTouch = () => {
  return (
    <div className="w-full relative min-h-screen bg-white flex flex-col box-border gap-20">
      <NavBarHome
        navBarHomeWidth="1690px"
        navBarHomePosition="absolute"
        navBarHomeTop="50px"
        navBarHomeLeft="113px"
        navBarHomeAlignSelf="unset"
      />

      <GetInTouch1 />

      <Address_Frame />
    </div>
  );
};

export default GetInTouch;
